module.exports = __webpack_public_path__ + "img/tl.78d60a92.svg";